module Meevo.Components.ScrollableLocationSelector {
    angular.module("meevo.components.scrollableLocationSelector", []);
}